import { useMutation, useQueryClient } from '@tanstack/react-query';
import { METHOD, sendJSONRequest } from '@/state/http-request.helpers.ts';
import { useAuth } from '@clerk/clerk-react';
import { GET_PRODUCTS_QUERY_KEY } from '@/state/queries/orders/use-get-products.ts';
import { ADMIN_PRODUCTS_QUERY_KEY } from '@/state/queries/admin/use-admin-products-query.ts';

export const useDeleteProductMutation = () => {
  const { getToken } = useAuth();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (id: string) => {
      const token = await getToken();
      const url = `${import.meta.env.VITE_API_URL}/products/${id}`;
      await sendJSONRequest({ url, method: METHOD.DELETE, token: token ?? '' });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [ADMIN_PRODUCTS_QUERY_KEY] });
      queryClient.invalidateQueries({ queryKey: [GET_PRODUCTS_QUERY_KEY] });
    },
  });
};
